import { Controller } from '@hotwired/stimulus';

// Enables the submit target only while at least one checkbox target is checked. A count target
// shows how many are, with its data-one text or with %count% in its data-other text.
export default class extends Controller {
    static targets = ['checkbox', 'submit', 'count'];

    connect() {
        this.update();
    }

    update() {
        const count = this.checkboxTargets.filter((checkbox) => checkbox.checked).length;

        this.submitTarget.disabled = 0 === count;
        this.countTargets.forEach((target) => {
            target.textContent = (1 === count ? target.dataset.one : target.dataset.other).replace('%count%', count);
        });
    }
}
